import FrequentlyAskedQuestion from "@components/FrequentlyAskedQuestion"
import { useTranslation } from "react-i18next"

export default function FrequentlyAskedQuestions() {
  const { t } = useTranslation()

  return (
    <div className="space-y-8">
      <p className="custom-heading text-center">
        {t("components.faq.heading")}
      </p>

      <div className="space-y-6">
        <FrequentlyAskedQuestion
          text={t("pages.onboarding.plans.faq.firstDescription")}
          title={t("pages.onboarding.plans.faq.firstHeadline")}
        />

        <FrequentlyAskedQuestion
          text={t("pages.onboarding.plans.faq.secondDescription")}
          title={t("pages.onboarding.plans.faq.secondHeadline")}
        />

        <FrequentlyAskedQuestion
          text={t("pages.onboarding.plans.faq.thirdDescription")}
          title={t("pages.onboarding.plans.faq.thirdHeadline")}
        />
      </div>
    </div>
  )
}
